import type { LiveClassPendingFeedback } from '@openeducation/oe-rn-shared-types';
import axios from 'axios';

import type { Environment } from '../interfaces/environment';
import { hostsConfig } from '../utils';

export default abstract class TeacherDao {
  static async getPendingFeedbackByTeacherId(
    env: Environment,
    sfdcFacultyId: string
  ) {
    const url = hostsConfig[env].courseServiceHost;

    const { data } = await axios.get<LiveClassPendingFeedback[]>(
      `${url}/v1/liveclassfeedbacks/pending`,
      {
        params: { sfdcFacultyId },
      }
    );

    return data;
  }
}
